import React from 'react';
import { pick, pipe, prop } from 'ramda';
import { Icon } from 'js/components/common/Icon';
import { FeatureIcon } from 'js/components/common/Game/FeatureIcons';
import { usePortletDispatch, usePortletSelector, usePortletTranslations } from 'js/components/system/Portlet';
import { deleteFilterAction } from './actions';
import { useCategoryName } from '../hooks/useCategoryName';
import style from './index.scss';
import { useAppSelector } from 'js/store/hooks';

export const Tags = () => {
    const categories = usePortletSelector(prop(['categories']));
    const { selectedCategories, selectedProviders, selectedFeatures } =
        usePortletSelector(pipe(prop('filters'), pick(['selectedCategories', 'selectedProviders', 'selectedFeatures'])));
    const games = useAppSelector(prop('games'));
    const t = usePortletTranslations();
    const dispatch = usePortletDispatch();
    const getFormattedCategoryName = useCategoryName();

    const categoriesTags = selectedCategories.map((id) => {
        const { displayName, mostPlayedGameCode } = categories.find(cat => cat.cid === id);
        const { name } = games?.[mostPlayedGameCode] || {};

        return {
            id,
            label: getFormattedCategoryName({ cid: id, categoryName: displayName, gameName: name })
        };
    });

    const featureTags = selectedFeatures.map(type => ({
        id: type,
        label: <FeatureIcon type={type} className={style.featureIcon} />,
        hint: t(`playtech.mobile.system.featured.${type}`)
    }));

    const providerTags = selectedProviders.map(type => ({
        id: type,
        label: type
    }));

    const tags = [...categoriesTags, ...providerTags, ...featureTags];

    return (
        tags.length > 0 && <div className={style.tagsContainer}>
            <div className={style.tags}>
                {tags.map(({ label, id }) => (
                    <div key={id} className={style.tag}>
                        {label}
                        <Icon
                            type="clearTag"
                            onClick={() => dispatch(deleteFilterAction(id))}
                            className={style.icon}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Tags;
